<div class="card only-stdcheck" *ngIf="upgrade" data-qa-id="Upgrade Widget">
  <div class="card-content">
    <div
      *ngIf="
        (is10TestPanelWithHivRnaUpgrade() && !hasHivRnaTest()) || (is13TestPanelWithHivRnaUpgrade() && has13TestPanel())
      "
      class="has-text-centered"
    >
      <strong class="has-text-primary-dark">Worried about recent exposure?</strong>
      <p class="mt-3">Upgrade with the</p>
      <h2 class="subtitle mb-0">HIV RNA Early Detection</h2>
    </div>

    <ng-container *ngIf="!!currentPanelContext">
      <ng-container *ngTemplateOutlet="panelWithOptionalHivRnaTemplate; context: currentPanelContext"> </ng-container>
    </ng-container>

    <hr class="separator" />

    <div class="columns is-vcentered">
      <div class="column is-7 upgrade__button_container">
        <button
          type="button"
          data-qa-id="Upgrade Submit"
          class="button is-large is-fullwidth has-text-white is-orange action"
          (click)="onUpgrade()"
        >
          <span>Upgrade Now</span>
        </button>
      </div>
      <div class="column is-5 has-text-right upgrade__price_container">
        <span class="subtitle mb-0 is-text-secondary-green" data-qa-id="Upgrade Additional Cost">
          +{{ upgradeTotal - currentTotal | centsCurrency }}
        </span>
      </div>
    </div>
  </div>
</div>

<!-- Reusable template for upgrading to a panel with optional HIV RNA -->
<ng-template
  #panelWithOptionalHivRnaTemplate
  let-panelName="panelName"
  let-tests="tests"
  let-showHivRnaTitle="showHivRnaTitle"
  let-showHivRnaAsItem="showHivRnaAsItem"
  let-title="title"
>
  <div class="has-text-centered">
    <strong class="has-text-primary-dark">{{ title }}</strong>
    <p class="mt-3">Upgrade to the</p>
    <h2 class="subtitle mb-0">{{ panelName }}</h2>
    <strong *ngIf="showHivRnaTitle" class="has-text-primary-dark">with HIV RNA Early Detection</strong>
  </div>
  <hr class="separator" />
  <div class="columns is-mobile is-multiline">
    <div *ngFor="let test of tests" class="column is-6 child-test">
      <i class="fa fa-check"></i><span>{{ test }}</span>
    </div>
    <div *ngIf="showHivRnaAsItem" class="column is-6 child-test">
      <i class="fa fa-check"></i><span>HIV RNA Early Detection</span>
    </div>
  </div>
</ng-template>
